angular
.module('inputTelWithPrefix.components', [])
.component('inputTelWithPrefix', {
	templateUrl: 'ng/components/inputTelWithPrefix/inputTelWithPrefix.html',
	bindings: {
		/** Input data **/
		inputId: '@',
        inputName: '@',
        prefixInputName: '@',
		inputClass: '@',
		inputPattern: '=',
		formName: '=',
		bindingVariable: '=',
		prefixBindingVariable: '=',
		/** Optional data **/
		inputDisableOn: '<'
	},
	controllerAs: 'inputTelWithPrefixCtrl',
	controller: function($translate, validationService) {
		
		/** not to loose *this reference **/
		var self = this;
		
		self.validationService = validationService;	
		
        self.$onInit = function () {
        	console.log(self);
        	self.inputDisableOn = self.inputDisableOn || false;
        }
        
        self.$onChanges = function(){

        }

      self.errorMsgShown = false;
      self.validationService = validationService;

      self.resetAlert = function(){
        self.errorMsgShown = false;
      }

      self.showAlertMsg = function(){
        self.errorMsgShown = !self.errorMsgShown;
      }

	  self.checkLength = function(){
		  if(!self.prefixBindingVariable && !self.bindingVariable){
			  return
		  }

		  var lenCompletePhone = self.prefixBindingVariable.concat(self.bindingVariable)
		  if(lenCompletePhone.length >12 && self.formName){
			  self.formName[self.inputName].$invalid= true;
			  self.formName[self.inputName].$setValidity(self.inputName, false);
			  self.formName[self.inputName].$error.required =true;
			  self.formName[self.prefixInputName].$error.required =true;
		  }else{
			  self.formName[self.inputName].$invalid= false;
			  self.formName[self.inputName].$setValidity(self.inputName, true);
			  self.formName[self.inputName].$error.required =false;
			  self.formName[self.prefixInputName].$error.required =false;
		  }
	  }
        
	}
});